module.exports = __webpack_public_path__ + "static/media/scoli1-4m.fda17fec.png";